import React, {useEffect} from 'react';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Avatar, Box, Divider, Drawer, Hidden, List, makeStyles, Typography} from '@material-ui/core';
import {Settings as SettingsIcon, Slack, DollarSign, LogOut} from 'react-feather';
import NavItem from './NavItem';
import {useSelector} from "react-redux";

const itemsWithWithdrawal = [
    {
        href: '/dashboard',
        icon: Slack,
        title: 'Dashboard'
    },
    {
        href: '/withdrawal',
        icon: DollarSign,
        title: 'Withdrawal'
    },
    {
        href: '/settings',
        icon: SettingsIcon,
        title: 'Settings'
    }
];

const itemsWithoutWithdrawal = [
    {
        href: '/dashboard',
        icon: Slack,
        title: 'Dashboard'
    },
    {
        href: '/settings',
        icon: SettingsIcon,
        title: 'Settings'
    }
];

const useStyles = makeStyles((theme) => ({
    mobileDrawer: {
        width: 256
    },
    desktopDrawer: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)'
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64
    }
}));

const NavBar = ({onMobileClose, openMobile}) => {
    const classes = useStyles();
    const location = useLocation();
    const {user} = useSelector(state => state.auth);

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose();
        }
    }, [location.pathname]);

    const content = (
        <Box height="100%" display="flex" flexDirection="column">
            <Box alignItems="center" display="flex" flexDirection="column" p={2}>
                <Avatar className={classes.avatar} component={RouterLink} to="/"/>
                <Typography className={classes.name} color="textPrimary" variant="h5">
                    {user.name} {user.surname}
                </Typography>
            </Box>
            <Divider/>
            <Box p={2}>
                <List>
                    {(user.withdrawalAuth ? itemsWithWithdrawal : itemsWithoutWithdrawal).map((item) => (
                        <NavItem href={item.href} key={item.title} title={item.title} icon={item.icon}/>
                    ))}
                    <NavItem href="/logout" key="Logout" title="Logout" icon={LogOut}/>
                </List>
            </Box>
        </Box>
    );

    return (
        <>
            <Hidden lgUp>
                <Drawer
                    anchor="left"
                    classes={{paper: classes.mobileDrawer}}
                    onClose={onMobileClose}
                    open={openMobile}
                    variant="temporary"
                >
                    {content}
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer
                    anchor="left"
                    classes={{paper: classes.desktopDrawer}}
                    open
                    variant="persistent"
                >
                    {content}
                </Drawer>
            </Hidden>
        </>
    );
};

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool
};

NavBar.defaultProps = {
    onMobileClose: () => {},
    openMobile: false
};

export default NavBar;
